var map = {
	"./20/1.png": "ee0c",
	"./20/10.png": "9dd4",
	"./20/11.png": "eb4b",
	"./20/12.png": "bb63",
	"./20/13.png": "e8ff",
	"./20/14.png": "079f",
	"./20/15.png": "d8ec",
	"./20/16.png": "99f7",
	"./20/17.png": "a4bb",
	"./20/18.png": "dae0",
	"./20/19.png": "bc01",
	"./20/2.png": "ecc0",
	"./20/20.png": "19d3",
	"./20/3.png": "a4bb7",
	"./20/4.png": "c41a",
	"./20/5.png": "759c",
	"./20/6.png": "e333",
	"./20/7.png": "3b49",
	"./20/8.png": "026b",
	"./20/9.png": "ca37",
	"./6/1.png": "11b0",
	"./6/2.png": "debb",
	"./6/3.png": "4a87",
	"./6/4.png": "745b",
	"./6/5.png": "880f",
	"./6/6.png": "72e1",
	"./SmartOrg-removebg-preview.png": "010c",
	"./SmartOrg.png": "659d",
	"./b4/1.png": "9acb",
	"./b4/2.png": "4c79",
	"./b4/3.png": "3fb7",
	"./b4/4.png": "5dd1",
	"./favicon-16x16.png": "6f68",
	"./innovationscreen.png": "68ba",
	"./logo.png": "cf05",
	"./w4/1.png": "0c98",
	"./w4/2.png": "0f26",
	"./w4/3.png": "2560",
	"./w4/4.png": "959f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";